import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXDatePicker from "../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { Divider } from "@mui/material";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const CrmReportFormStepOne = ({ offerResults, results, ...props }) => {
  const { t } = useTranslation();
  const [workers, setWorkers] = useState([]);
  const { values, form, setIsSubmit } = props;

  useEffect(() => {
    const loadData = async () => {
      const workerPayload = await GlobalAuthFetch({ path: "/worker/all" });
      setWorkers(workerPayload?.payload?.data || []);
    };

    loadData();
  }, []);

  const renderResultSection = (label, result) => (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <span>
        <b>{label}</b>
      </span>
      <span>{result}</span>
    </div>
  );

  return (
    <div className="CrmFormStepOne" style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={12}>
          <Field
            component={BMXSelectField}
            values={workers?.map((el) => ({
              name: `${el.firstName} ${el.lastName}`,
              value: el.uuid,
            }))}
            label={t("global:crm.worker")}
            name="worker"
            data-cy="worker"
          />
        </Col>
      </Row>

      <Row className="mt-2">
        <Col xs={6}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:crm.reportStartDate")}*`}
            name="reportStartDate"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:crm.reportEndDate")}*`}
            name="reportEndDate"
          />
        </Col>
      </Row>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BMXButton
          data-cy="save"
          type="submit"
          onClick={() => setIsSubmit(true)}
          bmxclass="Success"
          form={props.formName}
        >
          {t("global:crm.generateCrmReport")}
        </BMXButton>
      </div>

      <Divider sx={{ margin: "15px 0", borderColor: "var(--BMX-secondary)" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span>
          <b>OFERTY (0/0)</b>
        </span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          marginTop: "1rem",
        }}
      >
        {renderResultSection(
          "WYGRANE",
          offerResults.find((item) => item.type === "WIN")?.result || 0
        )}
        {renderResultSection(
          "PRZEGRANE",
          offerResults.find((item) => item.type === "LOSS")?.result || 0
        )}
      </div>

      <Divider sx={{ margin: "15px 0", borderColor: "var(--BMX-secondary)" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <span>
          <b>ZDARZENIA (0/0)</b>
        </span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          marginTop: "1rem",
        }}
      >
        {results.map((item) => (
          <div
            key={item.type}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span>
              <b>{t(`global:crm.${item.type.toLowerCase()}`)}</b>
            </span>
            <span>{item.result}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CrmReportFormStepOne;
